var React = require('react');

function YoutubeCircle (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"opacity":".2","cx":"28","cy":"28","r":"27","stroke":"#fff","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M36.962 23.478a2.346 2.346 0 0 0-1.65-1.661c-1.46-.393-7.293-.393-7.293-.393s-5.833 0-7.293.393a2.346 2.346 0 0 0-1.65 1.66c-.39 1.466-.39 4.523-.39 4.523s0 3.057.39 4.523a2.347 2.347 0 0 0 1.65 1.66c1.46.393 7.293.393 7.293.393s5.833 0 7.293-.393a2.347 2.347 0 0 0 1.65-1.66c.39-1.466.39-4.523.39-4.523s0-3.057-.39-4.522Z","fill":"#fff","key":1}),React.createElement("path",{"d":"M26.111 30.776v-5.551L30.991 28l-4.88 2.776Z","fill":"#000","key":2})]);
}

YoutubeCircle.defaultProps = {"width":"56","height":"56","viewBox":"0 0 56 56","fill":"none"};

module.exports = YoutubeCircle;

YoutubeCircle.default = YoutubeCircle;
